import { defineStore } from 'pinia';
import type { OnboardingLinkBody } from '~/types';
import { useAddAccountStore } from './accounts/add-account/add-account-store';
import { useAccountDetailsStore } from './accounts/account-details-store';

export const useOnboardingLinkStore = defineStore('onboarding-link', {
  state: () => ({
    currentStep: 1,
    isOnboardingModalOpen: false as boolean,
    redirectUrl: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    onboardingLink: undefined as string | undefined,
    openRegenerateOnboardingLink: false as boolean,
    onboardingNotCompleted: false as boolean
  }),

  actions: {
    openModal() {
      this.isOnboardingModalOpen = true;
    },
    openRegenerationModal() {
      this.currentStep = 1;
      this.onboardingNotCompleted = true;
      this.openModal();
    },
    onboardingLinkBody(isAccountDetails: boolean): OnboardingLinkBody {
      const { newAccountId } = useAddAccountStore();
      const { id } = useAccountDetailsStore();

      return {
        accountId: isAccountDetails ? id : newAccountId,
        redirectUrl: this.redirectUrl.value
      };
    }
  }
});
